import { motion } from "framer-motion";
import { Hammer, Sparkles, Clock, ArrowLeft } from "lucide-react";
import { Button } from "./button";
import { useNavigate } from "react-router-dom";

export function FeatureInDevelopment() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-gradient-to-br from-background via-background to-primary/5">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-2xl w-full"
      >
        <div className="bg-card border border-border rounded-2xl shadow-2xl overflow-hidden">
          {/* Header with gradient */}
          <div className="bg-gradient-to-r from-primary/20 via-primary/10 to-primary/20 p-8 text-center relative overflow-hidden">
            <motion.div
              animate={{
                rotate: [0, 10, -10, 0],
                scale: [1, 1.1, 1],
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                ease: "easeInOut",
              }}
              className="inline-block mb-4"
            >
              <div className="relative">
                <Hammer className="h-20 w-20 text-primary" strokeWidth={1.5} />
                <motion.div
                  animate={{
                    scale: [1, 1.2, 1],
                    opacity: [0.5, 1, 0.5],
                  }}
                  transition={{
                    duration: 2,
                    repeat: Infinity,
                    ease: "easeInOut",
                  }}
                  className="absolute -top-2 -right-2"
                >
                  <Sparkles className="h-8 w-8 text-primary" />
                </motion.div>
              </div>
            </motion.div>

            <h1 className="text-4xl font-bold text-foreground mb-2">
              Funcionalidade em Desenvolvimento
            </h1>
            <p className="text-muted-foreground text-lg">
              Estamos trabalhando duro para trazer esta feature para você
            </p>
          </div>

          {/* Content */}
          <div className="p-8 space-y-6">
            <div className="flex items-start gap-4 p-4 bg-primary/5 rounded-xl border border-primary/20">
              <Clock className="h-6 w-6 text-primary flex-shrink-0 mt-1" />
              <div>
                <h3 className="font-semibold text-foreground mb-1">
                  Em breve disponível
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  Nossa equipe está desenvolvendo esta funcionalidade com todo cuidado 
                  para garantir a melhor experiência possível. Em breve ela estará disponível 
                  para você!
                </p>
              </div>
            </div>

            <div className="space-y-3">
              <h3 className="font-semibold text-foreground flex items-center gap-2">
                <Sparkles className="h-5 w-5 text-primary" />
                Enquanto isso, você pode usar:
              </h3>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { name: "Dashboard", path: "/dashboard" },
                  { name: "Disparos", path: "/disparos" },
                  { name: "Cobrança Tática", path: "/follow-up-boletos" },
                  { name: "Central de Canhotos", path: "/canhotos" },
                  { name: "Contatos", path: "/contacts" },
                  { name: "Templates", path: "/templates" },
                ].map((feature) => (
                  <Button
                    key={feature.path}
                    variant="outline"
                    className="justify-start hover:bg-primary/10 hover:border-primary/50 transition-all"
                    onClick={() => navigate(feature.path)}
                  >
                    <span className="text-sm">{feature.name}</span>
                  </Button>
                ))}
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="bg-muted/30 p-6 flex justify-center">
            <Button
              onClick={() => navigate("/dashboard")}
              className="gap-2"
              size="lg"
            >
              <ArrowLeft className="h-4 w-4" />
              Voltar ao Dashboard
            </Button>
          </div>
        </div>
      </motion.div>
    </div>
  );
}
